// Store-Status (geöffnet/geschlossen) in Europe/Berlin, gerechnet im Browser, weil Shopify Seiten zwischenspeichert.
// Alle Werte und Sätze kommen aus snippets/kik-store-status.liquid (Theme-Einstellungen „Store, Versand und Kontakt“
// und Theme-Sprache kik.status). Hier stehen keine Zeiten und keine Texte.
//   data-zeiten        „0:;1:;2:11:00-19:00;…“ (0 = Sonntag, leer = geschlossen)
//   data-schliesstage  Zeilen „TT.MM.JJJJ“ oder „TT.MM.JJJJ - TT.MM.JJJJ“, mit „;“ getrennt
//   data-zu            „1“ = vorübergehend geschlossen, dazu data-zu-text
//   data-t-*           Sätze mit %open%, %close%, %tag%; data-tage = Kurznamen So bis Sa

class KikStoreStatus extends HTMLElement {
  connectedCallback() {
    this.label = this.querySelector('[data-store-status-text]');
    this.zeiten = this.leseZeiten(this.dataset.zeiten || '');
    this.schliesstage = this.leseSchliesstage(this.dataset.schliesstage || '');
    this.tage = (this.dataset.tage || '').split(',');
    this.update();
    this.timer = setInterval(() => this.update(), 60000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  leseZeiten(text) {
    const zeiten = {};
    text.split(';').forEach((eintrag) => {
      const [tag, spanne] = eintrag.split(/:(.*)/s);
      if (!spanne) return;
      const [von, bis] = spanne.split('-');
      zeiten[parseInt(tag, 10)] = { von: this.minuten(von), bis: this.minuten(bis), vonText: this.anzeige(von), bisText: this.anzeige(bis) };
    });
    return zeiten;
  }

  leseSchliesstage(text) {
    const tage = new Set();
    const datum = (wert) => {
      const teile = wert.trim().match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
      return teile ? new Date(Date.UTC(+teile[3], +teile[2] - 1, +teile[1])) : null;
    };
    text.split(';').forEach((zeile) => {
      const [a, b] = zeile.split(/\s*[-–]\s*/);
      const start = a && datum(a);
      if (!start) return;
      const ende = (b && datum(b)) || start;
      for (let d = new Date(start); d <= ende; d.setUTCDate(d.getUTCDate() + 1)) {
        tage.add(d.toISOString().slice(0, 10));
      }
    });
    return tage;
  }

  minuten(zeit) {
    const [h, m] = zeit.split(':').map((teil) => parseInt(teil, 10));
    return h * 60 + (m || 0);
  }

  anzeige(zeit) {
    return zeit.replace(/:00$/, '');
  }

  // Datum und Uhrzeit in Berlin, verschoben um tageVorwaerts
  berlin(tageVorwaerts = 0) {
    const jetzt = new Date(Date.now() + tageVorwaerts * 86400000);
    const teile = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(jetzt)
      .forEach((teil) => { teile[teil.type] = teil.value; });
    return {
      tag: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(teile.weekday),
      iso: `${teile.year}-${teile.month}-${teile.day}`,
      minuten: parseInt(teile.hour, 10) * 60 + parseInt(teile.minute, 10)
    };
  }

  offenAn(tag) {
    return this.zeiten[tag.tag] && !this.schliesstage.has(tag.iso) ? this.zeiten[tag.tag] : null;
  }

  update() {
    let text;
    let isOpen = false;

    if (this.dataset.zu === '1') {
      text = [this.dataset.tZu, this.dataset.zuText].filter(Boolean).join('. ');
    } else {
      const heute = this.berlin();
      const zeit = this.offenAn(heute);

      if (zeit && heute.minuten >= zeit.von && heute.minuten < zeit.bis) {
        isOpen = true;
        text = this.dataset.tOffen.replace('%close%', zeit.bisText);
      } else if (zeit && heute.minuten < zeit.von) {
        text = this.dataset.tHeute.replace('%open%', zeit.vonText);
      } else {
        for (let schritt = 1; schritt <= 60; schritt++) {
          const tag = this.berlin(schritt);
          const naechste = this.offenAn(tag);
          if (!naechste) continue;
          text = schritt === 1
            ? this.dataset.tMorgen.replace('%open%', naechste.vonText)
            : this.dataset.tTag.replace('%tag%', this.tage[tag.tag] || '').replace('%open%', naechste.vonText);
          break;
        }
      }
    }

    this.classList.toggle('is-open', isOpen);

    if (this.label && text) {
      this.label.textContent = text;
    }
  }
}

if (!window.customElements.get('kik-store-status')) {
  window.customElements.define('kik-store-status', KikStoreStatus);
}
